import { DialogId, NlpModelId, StepId } from '@feedyou/schema'
import _ from 'lodash'
import { BotHeaderTab, BotHeaderTabType } from './types'

export const TAB_TYPE_SEPARATOR = '_'

export const areTheSameTab = (tab1: BotHeaderTab, tab2: BotHeaderTab) => {
  return tab1.id === tab2.id && tab1.type === tab2.type
}

export const isTabContainedInList = (tab: BotHeaderTab, tabs: BotHeaderTab[]) => {
  return tabs.some(t => areTheSameTab(t, tab))
}

export const removeTabFromList = (tab: BotHeaderTab, tabs: BotHeaderTab[]) => {
  return tabs.filter(t => !areTheSameTab(t, tab))
}

export const removeTabsFromList = (tabsToRemove: BotHeaderTab[], tabs: BotHeaderTab[]) => {
  return _.differenceWith(tabs, tabsToRemove, areTheSameTab)
}

export const createDialogTab = (dialogId: DialogId): BotHeaderTab => {
  return { type: BotHeaderTabType.Dialog, id: dialogId }
}

export const createNlpModelTab = (nlpModelId: NlpModelId, nlpModelName?: string): BotHeaderTab => {
  return { type: BotHeaderTabType.NlpModel, id: nlpModelId, title: nlpModelName }
}

export const createKnowledgeBaseTab = (
  knowledgeBaseId: string,
  knowledgeBaseName?: string
): BotHeaderTab => {
  return { type: BotHeaderTabType.KnowledgeBase, id: knowledgeBaseId, title: knowledgeBaseName }
}

export const createStepNlpModelTab = (stepId: string): BotHeaderTab => {
  return { type: BotHeaderTabType.StepNlpModel, id: stepId }
}

export const createNlpTrainingTab = (): BotHeaderTab => {
  return { type: BotHeaderTabType.NlpTraining }
}

export const createNlpQueriesTab = (): BotHeaderTab => {
  return { type: BotHeaderTabType.NlpChatQueries }
}

export const isTabClosable = (tab: BotHeaderTab, pinnedDialogs: DialogId[]) => {
  if (tab.type === BotHeaderTabType.StepNlpModel) {
    return true
  }

  if (tab.type === BotHeaderTabType.Dialog && ![...pinnedDialogs].includes(tab.id as any)) {
    return true
  }

  return false
}

export const isTabOfType = (type: BotHeaderTabType) => (tab: BotHeaderTab) => {
  return tab.type === type
}

export const getKey = (tab: BotHeaderTab): string => {
  return !!tab?.id ? `${tab.type}${TAB_TYPE_SEPARATOR}${tab.id}` : tab.type
}
